import { useLanguage } from "@/contexts/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Skeleton } from "@/components/ui/skeleton";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { trpc } from "@/lib/trpc";
export default function FaqPage() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  useDocumentMeta("FAQ | CYPRUS PRIVÉ", "Antworten zu Firmengründung, Banking, Paketen, Discovery Experience, Stay und Private Investments in Nordzypern.");
  const {
    data,
    isLoading
  } = trpc.public.bootstrap.useQuery();
  type FaqItem = NonNullable<typeof data>["faqs"][number];
  const grouped = Object.entries((data?.faqs ?? []).reduce<Record<string, FaqItem[]>>((result, item) => {
    (result[item.category] ??= []).push(item);
    return result;
  }, {}));
  const schema = data?.faqs.length ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: data.faqs.map(item => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }))
  } : null;
  return <main>{tx(schema && <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />)}<section className="bg-[#101010] py-24 text-white lg:py-32"><div className="container"><p className="text-[10px] font-bold tracking-[.23em] text-[#C4A46B]">{tx("FAQ")}</p><h1 className="mt-5 display-lg font-semibold">{tx("KLARE ANTWORTEN.")}<br />{tx("PERSÖNLICHE PRÜFUNG.")}</h1><p className="mt-6 max-w-2xl text-lg leading-8 text-white/62">{tx("Allgemeine Orientierung vor dem Gespräch. Dein konkretes Vorhaben betrachten wir individuell.")}</p></div></section><section className="paper-grain py-24"><div className="container max-w-5xl">{tx(isLoading ? <div className="space-y-4">{tx([1, 2, 3, 4].map(i => <Skeleton key={i} className="h-20 rounded-none" />))}</div> : grouped.map(([category, items]) => <section key={category} className="mb-16 grid gap-8 lg:grid-cols-[.35fr_1fr]"><div><p className="eyebrow">{tx(category)}</p></div><Accordion type="single" collapsible className="border-t border-[#DED6C8]">{tx(items.map(item => <AccordionItem key={item.id} value={String(item.id)}><AccordionTrigger className="py-6 text-left font-sans text-lg font-semibold hover:no-underline">{tx(item.question)}</AccordionTrigger><AccordionContent className="pb-6 text-base leading-8 text-[#66615A]">{tx(item.answer)}</AccordionContent></AccordionItem>))}</Accordion></section>))}</div></section></main>;
}
